// Libraries
import { CloseIcon } from '@chakra-ui/icons';
import { Flex, IconButton } from '@chakra-ui/react';
// Types
import { DialogerHeaderProps } from './Dialoger.types';
// Utils
import text from '@translations/en.json';

/**
 * The `DialogerHeader` component displays a JSX. Element.
 *
 * @component
 * @param {DialogerHeaderProps} props - The component props.
 * @param {Function} props.onClose - The function to close the dialoger.
 * @param {ReactElement} props.children - The rendered element to show in the header.
 * @returns {ReactElement} - The `DialogerHeader` component.
 */
export const DialogerHeader = ({ onClose, children }: DialogerHeaderProps) => {
  return (
    <Flex flexDir='row' justifyContent='space-between' alignItems='center'>
      {children}
      <IconButton
        p={2}
        h={8}
        minW={8}
        aria-label={text.close_menu}
        variant='baseLight'
        icon={<CloseIcon color='text.faded' />}
        onClick={onClose}
      />
    </Flex>
  );
};
